import React from "react";
import { Link } from "react-router-dom";
import { NavLink } from "reactstrap";
import Edit from "../../../images/edit.svg";
import Delete from "../../../images/delete.svg";

function ActionFormatter({ id, rowData, editFunction, deleteFunction }) {
	return (
		<div className="navLinkClass">
			<Link
				onClick={() => {
					editFunction(rowData);
				}}
			>
				<img
					style={{
						height: "18px",
						width: "18px",
						cursor: "pointer",
					}}
					src={Edit}
					alt="Edit"
				/>
			</Link>
			<NavLink
				onClick={() => {
					deleteFunction(id);
				}}
			>
				<img
					style={{
						height: "18px",
						width: "18px",
						cursor: "pointer",
					}}
					src={Delete}
					alt="Delete"
				/>
			</NavLink>
		</div>
	);
}

export default ActionFormatter;
